export const INVESTIGATION_DRAFT_KEY = "hrms-investigation-draft";
export const INVESTIGATION_FOCUS_KEY = "hrms-investigation-focus";

export function queueInvestigationDraft(complaint) {
  const complaintId = complaint?._backendId || complaint?.id;
  if (!complaintId) return;
  sessionStorage.setItem(
    INVESTIGATION_DRAFT_KEY,
    JSON.stringify({
      complaintId,
      title: complaint.title || "",
    }),
  );
}

export function focusInvestigation(id) {
  if (!id) return;
  sessionStorage.setItem(INVESTIGATION_FOCUS_KEY, String(id));
  window.dispatchEvent(new Event("investigation:focus"));
}
